import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { AddUploadTrackEntryForm } from '@/components/forms/AddUploadTrackEntryForm/AddUploadTrackEntryForm'
import { AddUploadTrackEntryFormFields } from '@/components/forms/AddUploadTrackEntryForm/AddUploadTrackEntryFormFields'

export interface AddUploadTrackEntryModalProps extends DialogProps {}

export const AddUploadTrackEntryModal: React.FC<AddUploadTrackEntryModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddUploadTrackEntryForm defaultValues={{ update_type: 'create' }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader className={'mb-4'}>
                  <DialogTitle>Add Upload Track Entry</DialogTitle>
                </DialogHeader>
                <AddUploadTrackEntryFormFields />
                <DialogFooter className={'mt-4'}>
                  <Button
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton size="sm" loading={isSubmitting} disabled={!isValid}>
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddUploadTrackEntryForm>
      </DialogContent>
    </Dialog>
  )
}
